import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import type {DhiraaguUserTemplateColumnIds} from "../dhiraagu/Users";

export enum EmotoradRoles {
    /** Full workspace access; reports to no one. */
    SystemAdmin = "9695cec3-eac6-562f-b1c7-6545a0e8b85e",
    /** Country-level full access; reports to no one. */
    SuperAdmin = "e3270405-8c3a-5a54-940f-bf21827d920b",
    /** Regional / multi-area; reports to Super Admin. */
    RM = "a0c7e2f3-957e-594c-8f27-cbf57cadae6b",
    /** Multi-area; reports to RM. */
    KAM = "9d380179-1e25-55a0-98de-3378187b5b72",
    /** Multiple dealerships; reports to KAM. */
    DealershipOwner = "df746506-622d-5487-a162-8760dadaaf0a",
    /** Single dealership; reports to Dealership owner. */
    StoreManager = "694a0fd1-d8e4-56e6-9283-f70142e1524a",
    /** Single dealership, assigned data; reports to Store manager. */
    StoreSalesExecutive = "d661f43b-54af-596e-afac-4d11d18cb6b0",
}

export const EMOTORAD__USER__NAME__COLUMN_ID = "7c29743e-3ca5-5282-a758-d6260dcb3964" as Uuid;

export const EMOTORAD__USER__DISPLAY_NAME__COLUMN_ID = "e4eca72b-9794-51e3-b10f-1fd59245ca05" as Uuid;

export const EMOTORAD__USER__EMAIL__COLUMN_ID = "efcaa552-378f-5a9b-8105-5f4a3aedb6b4" as Uuid;

export const EMOTORAD__USER__CONTACT_NUMBER__COLUMN_ID = "d2d61815-7536-5867-9b0b-87fc2b7492c1" as Uuid;

export const EMOTORAD__USER__DOB__COLUMN_ID = "e5327955-1c46-50a3-9fe0-f3056727234f" as Uuid;

export const EMOTORAD__USER__GENDER__COLUMN_ID = "86d06959-3ee9-54ab-8e66-84db22548d70" as Uuid;

export const EMOTORAD__USER__STAFF_CODE__COLUMN_ID = "50a8c877-1cc7-549b-bda7-0cf6757a56a9" as Uuid;

export const EMOTORAD__USER__PROFILE_IMAGE_URL__COLUMN_ID = "85ed436e-6a5c-559b-8481-2c74eb62e1af" as Uuid;

export const EMOTORAD__USER__VERIFICATION_INVITED_AT__COLUMN_ID = "427a54cc-e939-5607-a0aa-709186ce9827" as Uuid;

export const EMOTORAD__USER__VERIFICATION_INVITED_BY__COLUMN_ID = "6179d218-d704-51ae-9680-56532e46b401" as Uuid;

export const EMOTORAD__USER__VERIFICATION_SUBMITTED_ON__COLUMN_ID = "318548ce-018c-52ba-b53e-3e726eeca62c" as Uuid;

export const EMOTORAD__USER__VERIFICATION_PROCESSED_ON__COLUMN_ID = "b07f5e7e-8f6d-51df-97ef-e016448dee41" as Uuid;

export const EMOTORAD__USER__VERIFICATION_PROCESSED_BY__COLUMN_ID = "2e6dc711-ec8b-5634-ae72-ab2c7e4e5e7c" as Uuid;

export const EMOTORAD__USER__VERIFICATION_REJECT_REASON__COLUMN_ID = "8074805b-901f-5505-a689-1d352a3edb4d" as Uuid;

export const EMOTORAD__USER__COUNTRY__COLUMN_ID = "3379c627-d301-5c16-a950-fc1ffc192969" as Uuid;

export const EMOTORAD__USER__AREA__COLUMN_ID = "8d53d69c-ec84-5c7f-b432-0bf93d805bc9" as Uuid;

export const EMOTORAD__USER__DEALERSHIP__COLUMN_ID = "85bd11a0-6418-5c03-9764-b3f036d36bdb" as Uuid;

export const EMOTORAD__USER__ALTERNATE_CONTACT__COLUMN_ID = "e122f3b9-2c16-48c3-9a9d-77e5b6d03a34" as Uuid;

export const EMOTORAD__USER__STORE_STAFF__ALTERNATE_CONTACT__COLUMN_ID = "b8763e25-29a8-43c1-ae1c-3d69a8fc30f0" as Uuid;

export const EMOTORAD__USER__STORE_STAFF__WHATSAPP_CONTACT__COLUMN_ID = "5ae89486-4ecc-48d9-9fe6-ef5adebb98ab" as Uuid;

export const EMOTORAD__USER__STORE_STAFF__ADDRESS_STATE__COLUMN_ID = "ff09471f-4d41-4948-910d-dbeba41953c1" as Uuid;

export const EMOTORAD__USER__STORE_STAFF__ADDRESS_CITY__COLUMN_ID = "45f9b8f7-f0b1-44fd-8645-0b398f38a3a1" as Uuid;

export const EMOTORAD__USER__STORE_STAFF__HOUSE_NUMBER__COLUMN_ID = "1e13d660-3d82-459a-acfa-590e0d37a8e1" as Uuid;

export const EMOTORAD__USER__STORE_STAFF__AREA_LOCALITY__COLUMN_ID = "0f0707a6-a344-4668-9a66-74fd6ba6603e" as Uuid;

export const EMOTORAD__USER__STORE_STAFF__AADHAR__COLUMN_ID = "38b83220-48f4-47db-b522-c0c5e1bb9697" as Uuid;

export const EMOTORAD__USER__STORE_STAFF__PAN__COLUMN_ID = "c16d22c4-f1a1-4376-94a3-6bc9c403cc2c" as Uuid;

export const EMOTORAD__USER__WHATSAPP_CONTACT__COLUMN_ID = "e4ef0b74-4563-4e84-b104-77abb9bb0b73" as Uuid;

export const EMOTORAD__USER__ADDRESS_STATE__COLUMN_ID = "cda5321b-79fe-4731-aea1-e368763f3388" as Uuid;

export const EMOTORAD__USER__ADDRESS_CITY__COLUMN_ID = "e964cb67-b1f2-484f-a356-10199bc19ba8" as Uuid;

export const EMOTORAD__USER__ADDRESS_PINCODE__COLUMN_ID = "13655fbc-54c9-4e0a-a22e-f6ccc5e55079" as Uuid;

export const EMOTORAD__USER__HOUSE_NUMBER__COLUMN_ID = "a8beb3b5-cd57-427b-a30c-c75c4970eda1" as Uuid;

export const EMOTORAD__USER__AREA_LOCALITY__COLUMN_ID = "4e1c1ba4-aeab-4b72-ac30-8d56e0563a2a" as Uuid;

export const EMOTORAD__USER__GST_NUMBER__COLUMN_ID = "21618047-7234-48dd-b19e-18555fd98596" as Uuid;

export const EMOTORAD__USER__AADHAR__COLUMN_ID = "450f5bb7-92d7-4712-adf8-e32c5f632fef" as Uuid;

export const EMOTORAD__USER__PAN__COLUMN_ID = "1844cb84-083d-47e6-bdf5-18c611f5c881" as Uuid;

export const EMOTORAD__USER__STORE_STAFF__STATUS__COLUMN_ID = "a1b2c3d4-e5f6-7890-abcd-ef1234567890" as Uuid;

export const EMOTORAD__USER__ASSIGNED_DEALER__COLUMN_ID = "b2c3d4e5-f6a7-8901-bcde-f12345678901" as Uuid;

export const EMOTORAD__USER__LAST_ACTIVE_ON__COLUMN_ID = "e5f6a7b8-c9d0-1234-ef01-345678901234" as Uuid;

export const EMOTORAD__USER__ACTIVE_LIFECYCLE_COUNT__COLUMN_ID = "f6a7b8c9-d0e1-2345-f012-456789012345" as Uuid;

export const EMOTORAD__USER__TOTAL_LEAD_COUNT__COLUMN_ID = "a7b8c9d0-e1f2-3456-0123-567890123456" as Uuid;

export const EMOTORAD__USER__CONVERTED_LIFECYCLE_COUNT__COLUMN_ID = "b8c9d0e1-f2a3-4567-1234-678901234567" as Uuid;

export const EMOTORAD__USER__CALLS_COUNT__COLUMN_ID = "c9d0e1f2-a3b4-5678-2345-789012345678" as Uuid;

export const EMOTORAD__USER__WALKIN_COUNT__COLUMN_ID = "d0e1f2a3-b4c5-6789-3456-890123456789" as Uuid;

export const EMOTORAD__USER__TEST_RIDE_COUNT__COLUMN_ID = "e1f2a3b4-c5d6-7890-4567-901234567890" as Uuid;

export const EMOTORAD__USER__SALES_COUNT__COLUMN_ID = "f2a3b4c5-d6e7-8901-5678-012345678901" as Uuid;

export const EMOTORAD__USER__CREATED_ON__COLUMN_ID = "a3b4c5d6-e7f8-9012-6789-123456789012" as Uuid;

export const EMOTORAD__USER__CREATED_BY__COLUMN_ID = "b4c5d6e7-f8a9-0123-7890-234567890123" as Uuid;

/**
 * Semantic column IDs for Emotorad user templates — same shape as Dhiraagu; validated by
 * {@link parseUserTemplateColumnMap} from `usersModuleDhiraagu`.
 */
export type EmotoradUserTemplateColumnIds = DhiraaguUserTemplateColumnIds;
